import React from 'react';

import { sendLinkFailureNotice } from '@personal-trainer-app/shared';

import type { SendLinkFailureAlertProps } from './SendLinkFailureAlert.types';

import { Alert } from '@/components/ui';

/**
 * Over the button that asked for a new link, why it failed. Nothing was sent,
 * so the button stays for another try.
 */
export function SendLinkFailureAlert({
  failure,
  className = '',
}: SendLinkFailureAlertProps): React.JSX.Element {
  const notice = sendLinkFailureNotice(failure);
  return (
    <Alert variant={notice.variant} title={notice.title} className={className}>
      {notice.body}
    </Alert>
  );
}

export default SendLinkFailureAlert;
